import { useEffect, useState } from "react";
import { X, Rocket, Loader2, Flame } from "lucide-react";
import { fetchBoostOptions, startBoost } from "@/lib/api";
import { fmtPrice } from "@/lib/utils";
import { PaymentMethodPicker } from "@/components/PaymentMethodPicker";

export const BoostModal = ({ annonce, onClose }) => {
  const [options, setOptions] = useState([]);
  const [fid, setFid] = useState(null);
  const [hours, setHours] = useState(48);
  const [payOpts, setPayOpts] = useState({});
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => { fetchBoostOptions().then((r) => { setOptions(r.options); setFid(r.fidelite || null); }).catch(() => {}); }, []);
  const gratuit = !!fid?.gratuit;
  const sel = options.find((o) => o.hours === hours);
  const active = annonce?.boosted_until && new Date(annonce.boosted_until) > new Date();

  const pay = async () => {
    setBusy(true); setErr("");
    try {
      const r = await startBoost(annonce.id, { hours, ...payOpts });
      window.location.href = r.payment_url;
    } catch (e) { setErr(e?.response?.data?.detail || "Paiement impossible"); setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-end sm:items-center justify-center p-3" onClick={onClose} data-testid="boost-modal">
      <div className="bg-white w-full max-w-md rounded-3xl shadow-2xl p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-[11px] font-bold uppercase tracking-widest text-orange-600 inline-flex items-center gap-1"><Flame size={12} /> Annonce a la une</div>
            <h3 className="text-xl font-black mt-1">Booster « {annonce.title} »</h3>
            <p className="text-sm text-neutral-600 mt-1">Votre annonce apparait <b>en tete de sa categorie</b> et de toutes les recherches pendant la duree choisie, avec le badge « A la une ».</p>
          </div>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-neutral-100" aria-label="Fermer" data-testid="boost-close"><X size={18} /></button>
        </div>
        {active && <div className="mt-3 text-xs font-semibold text-emerald-700 bg-emerald-50 rounded-xl px-3 py-2" data-testid="boost-active-note">Boost deja actif jusqu'au {new Date(annonce.boosted_until).toLocaleString("fr-FR")} — la nouvelle duree s'ajoutera.</div>}
        {fid && (
          <div className={`mt-3 rounded-xl px-3 py-2 text-xs font-semibold ${gratuit ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-900"}`} data-testid="boost-fidelite">
            {gratuit ? "Fidelite : ce boost vous est OFFERT (11e boost) !" : `Fidelite : ${fid.nb_boosts_payes}/${fid.seuil} boosts payes — plus que ${fid.restants} avant votre boost offert.`}
            {!gratuit && <div className="mt-1.5 h-1.5 rounded-full bg-amber-200 overflow-hidden"><div className="h-full bg-amber-500" style={{ width: `${(fid.nb_boosts_payes / fid.seuil) * 100}%` }} /></div>}
          </div>
        )}
        <div className="mt-4 grid grid-cols-3 gap-2">
          {options.map((o) => (
            <button key={o.hours} type="button" onClick={() => setHours(o.hours)} className={`rounded-2xl border-2 p-3 text-center transition ${hours === o.hours ? "border-orange-500 bg-orange-50" : "border-neutral-200 hover:border-orange-300"}`} data-testid={`boost-option-${o.hours}`}>
              <div className="text-2xl font-black">{o.hours}h</div>
              <div className="text-xs font-bold text-orange-600">{gratuit ? <span><s className="text-neutral-400">{fmtPrice(o.amount)}</s> Offert</span> : fmtPrice(o.amount)}</div>
              {o.hours === 48 && <div className="text-[10px] font-bold text-emerald-700 mt-1">Populaire</div>}
            </button>
          ))}
        </div>
        {!gratuit && <div className="mt-4"><PaymentMethodPicker value={payOpts} onChange={setPayOpts} amount={sel?.amount || 0} /></div>}
        <button type="button" onClick={pay} disabled={busy || !sel} className="btn-primary w-full mt-4 inline-flex items-center justify-center gap-2 disabled:opacity-50" data-testid="boost-pay-btn">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Rocket size={16} />} {gratuit ? `Activer mon boost offert ${hours}h` : `Payer ${sel ? fmtPrice(sel.amount) : ""} et booster ${hours}h`}
        </button>
        {err && <div className="mt-2 text-sm font-semibold text-red-600" data-testid="boost-error">{err}</div>}
        <p className="mt-3 text-[11px] text-neutral-500">Mobile Money (Orange, Wave, MTN, Moov) ou carte. Le boost demarre des la confirmation du paiement.</p>
      </div>
    </div>
  );
};
